// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commonStarsRating[data-v-053152b4]{display:flex;flex-direction:row;align-items:center;gap:6px}.commonStarsRating_trustpilot[data-v-053152b4]{gap:2px}.commonStarsRating_element_medium[data-v-053152b4]{height:24px;width:24px}.commonStarsRating_element_large[data-v-053152b4]{height:32px;width:32px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
